"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSelectDTO = exports.TicketSelectDTOSchema = exports.TicketDTOSchema = exports.TicketSchema = exports.TicketBaseSchema = exports.CertificateNameSchema = exports.CertificateNameBaseSchema = exports.CategorySchema = exports.CategoryBaseSchema = exports.IssuingBodySchema = exports.IssuingBodyBaseSchema = exports.TrainingProviderSchema = exports.TrainingProviderBaseSchema = exports.STCWSchema = exports.STCWBaseSchema = exports.TicketNameDTOSchema = void 0;
var zod_1 = require("zod");
var const_1 = require("./const");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
// Support Models / Schemas for the actual ticket.
var TicketNameBaseSchema = zod_1.z.object({
    Name: zod_1.z.string().min(5, 'The name is too short').max(140, 'The name is too long'),
    isHidden: zod_1.z.boolean().default(false).optional(),
    hiddenAt: zod_1.z.coerce.date().nullable().optional(),
    hiddenBy: zod_1.z.instanceof(ObjectId_1.ObjectId).nullable().optional(),
});
var TicketNameSchema = TicketNameBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.TicketNameDTOSchema = TicketNameBaseSchema.extend({
    _id: zod_1.z.string(),
    hiddenBy: zod_1.z.string().nullable().optional(),
});
exports.STCWBaseSchema = TicketNameBaseSchema;
exports.STCWSchema = TicketNameSchema;
exports.TrainingProviderBaseSchema = TicketNameBaseSchema;
exports.TrainingProviderSchema = TicketNameSchema;
exports.IssuingBodyBaseSchema = TicketNameBaseSchema;
exports.IssuingBodySchema = TicketNameSchema;
exports.CategoryBaseSchema = TicketNameBaseSchema;
exports.CategorySchema = TicketNameSchema;
exports.CertificateNameBaseSchema = TicketNameBaseSchema.extend({
    CategoryId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Order: zod_1.z.number(),
});
exports.CertificateNameSchema = exports.CertificateNameBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
// This covers everything for the Support, now let's create the Ticket schema.
/*
Certificate Name -> Ticket Name
Issuer -> Issuing Body
SCTW
Certificate Number
Awarded -> Day Awarded
Expiry Date
Details (there’s a set amount of info) -> Limitations
School -> Training Provider
On their last email they've added:
Added On
Issued On
QR Code Check	??? Yes / No / undefined
Status -> Pending / Sighted / Verified / Declined
*/
exports.TicketBaseSchema = zod_1.z.object({
    CertificateNameId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    IssuingBodyId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    STCWId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    TrainingProviderId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    DateAwarded: zod_1.z.coerce.date().optional(),
    DateExpiry: zod_1.z.coerce.date().optional(),
    DateIssued: zod_1.z.coerce.date(),
    Limitations: zod_1.z.string().optional(), //????
    QRCodeCheck: zod_1.z.boolean().optional(), //????
    Status: zod_1.z.string().default(const_1.DocumentStatus.UPLOADED),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Notes: zod_1.z.string().optional(),
    UploadUrl: zod_1.z.string(),
    // PMM-616
    CertificateNumber: zod_1.z.string().optional(),
    /** Date the certificate status was last set (e.g. sighted/verified); used on DSRB instead of refresh date */
    StatusDate: zod_1.z.coerce.date().optional(),
    assignedAdminId: zod_1.z
        .union([zod_1.z.string(), zod_1.z.instanceof(ObjectId_1.ObjectId)])
        .nullable()
        .optional(),
    adminWorkflowStatus: zod_1.z.enum(const_1.AdminWorkflowStatusArray).default('Pending'),
    assignedAt: zod_1.z.coerce.date().nullable().optional(),
    lastAdminEditDate: zod_1.z.coerce.date().optional(),
    lastAdminEdit: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    lastSRBOfficerEditDate: zod_1.z.coerce.date().optional(),
    lastSRBOfficerEdit: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    reviewComments: zod_1.z.string().optional(),
});
exports.TicketSchema = exports.TicketBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var ticketWorkflowFields = {
    assignedAdminId: true,
    adminWorkflowStatus: true,
    assignedAt: true,
    lastAdminEditDate: true,
    lastAdminEdit: true,
    lastSRBOfficerEditDate: true,
    lastSRBOfficerEdit: true,
    reviewComments: true,
};
exports.TicketDTOSchema = exports.TicketBaseSchema.omit(__assign({ UserId: true, CertificateNameId: true, IssuingBodyId: true, STCWId: true, TrainingProviderId: true }, ticketWorkflowFields)).extend({
    UserId: zod_1.z.string(),
    STCWId: zod_1.z.string().optional(),
    CertificateNameId: zod_1.z.string(),
    IssuingBodyId: zod_1.z.string(),
    TrainingProviderId: zod_1.z.string(),
});
exports.TicketSelectDTOSchema = exports.TicketDTOSchema.extend({
    STCW: zod_1.z.string().optional(),
    CertificateName: zod_1.z.string(),
    IssuingBody: zod_1.z.string(),
    TrainingProvider: zod_1.z.string(),
    STCWId: exports.TicketNameDTOSchema,
    CertificateNameId: exports.TicketNameDTOSchema.extend({ CategoryId: zod_1.z.string() }),
    IssuingBodyId: exports.TicketNameDTOSchema,
    TrainingProviderId: exports.TicketNameDTOSchema,
    _id: zod_1.z.string(),
});
exports.TicketSelectDTO = {
    convertFromModel: function (model) {
        var _a, _b, _c, _d;
        var dto = __assign(__assign({}, model), { STCW: (_a = model.STCWId) === null || _a === void 0 ? void 0 : _a.Name, CertificateName: (_b = model.CertificateNameId) === null || _b === void 0 ? void 0 : _b.Name, IssuingBody: (_c = model.IssuingBodyId) === null || _c === void 0 ? void 0 : _c.Name, TrainingProvider: (_d = model.TrainingProviderId) === null || _d === void 0 ? void 0 : _d.Name });
        return dto;
    },
};
//# sourceMappingURL=Ticket.js.map